var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartOutlineX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5146 4.23278C11.6841 4.37753 11.8462 4.53132 12 4.69342C12.1538 4.53132 12.3159 4.37753 12.4854 4.23278C13.5701 3.30656 14.9617 2.75 16.4792 2.75C19.9425 2.75 22.75 5.6489 22.75 9.22504C22.75 15.7757 16.8438 18.7784 13.1389 20.6621C12.7286 20.8707 12.3453 21.0656 12 21.25C11.6547 21.0656 11.2714 20.8707 10.8611 20.6621C7.15616 18.7784 1.25 15.7757 1.25 9.22504C1.25 5.6489 4.05754 2.75 7.52083 2.75C9.03833 2.75 10.4299 3.30656 11.5146 4.23278ZM12 18.996C12.1075 18.9411 12.2159 18.8858 12.3252 18.8301C13.9591 17.9976 15.783 17.0683 17.3988 15.7314C19.3604 14.1082 20.75 12.0804 20.75 9.22504C20.75 6.69258 18.778 4.75 16.4792 4.75C15.3055 4.75 14.2342 5.24465 13.4507 6.07018L12 7.5988L10.5493 6.07018C9.76585 5.24465 8.69451 4.75 7.52083 4.75C5.22203 4.75 3.25 6.69258 3.25 9.22504C3.25 12.0804 4.63956 14.1082 6.60124 15.7314C8.217 17.0683 10.0409 17.9976 11.6748 18.8301C11.7841 18.8858 11.8925 18.9411 12 18.996Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutlineX2);
export default __webpack_public_path__ + "static/media/HeartOutlineX2.b88951e19345fb0227123e59293c47e0.svg";
export { ForwardRef as ReactComponent };